// FIFA 2026 World Cup third-place allocation — Annex C of the tournament
// regulations: all 495 combinations of which 8 of the 12 groups produce a
// qualifying third-placed team. Key = those 8 group letters, sorted. Value =
// the qualifying third's group for each winner column, in column order
// 1A,1B,1D,1E,1G,1I,1K,1L (see WINNER_ORDER in knockout.ts).
//
// Generated and integrity-checked (knockout.test.ts) from the authoritative
// mirror of Annex C:
//   https://en.wikipedia.org/wiki/Template:2026_FIFA_World_Cup_third-place_table
// Do not hand-edit.
export const THIRD_PLACE_ALLOCATION: Record<string, string> = {
  EFGHIJKL: 'EJIFHGLK',
  DFGHIJKL: 'HGIDJFLK',
  DEGHIJKL: 'EJIDHGLK',
  DEFHIJKL: 'EJIDHFLK',
  DEFGIJKL: 'EGIDJFLK',
  DEFGHJKL: 'EGJDHFLK',
  DEFGHIKL: 'EGIDHFLK',
  DEFGHIJL: 'EGJDHFLI',
  DEFGHIJK: 'EGJDHFIK',
  CFGHIJKL: 'HGICJFLK',
  CEGHIJKL: 'EJICHGLK',
  CEFHIJKL: 'EJICHFLK',
  CEFGIJKL: 'EGICJFLK',
  CEFGHJKL: 'EGJCHFLK',
  CEFGHIKL: 'EGICHFLK',
  CEFGHIJL: 'EGJCHFLI',
  CEFGHIJK: 'EGJCHFIK',
  CDGHIJKL: 'HGICJDLK',
  CDFHIJKL: 'CJIDHFLK',
  CDFGIJKL: 'CGIDJFLK',
  CDFGHJKL: 'CGJDHFLK',
  CDFGHIKL: 'CGIDHFLK',
  CDFGHIJL: 'CGJDHFLI',
  CDFGHIJK: 'CGJDHFIK',
  CDEHIJKL: 'EJICHDLK',
  CDEGIJKL: 'EGICJDLK',
  CDEGHJKL: 'EGJCHDLK',
  CDEGHIKL: 'EGICHDLK',
  CDEGHIJL: 'EGJCHDLI',
  CDEGHIJK: 'EGJCHDIK',
  CDEFIJKL: 'CJEDIFLK',
  CDEFHJKL: 'CJEDHFLK',
  CDEFHIKL: 'CEIDHFLK',
  CDEFHIJL: 'CJEDHFLI',
  CDEFHIJK: 'CJEDHFIK',
  CDEFGJKL: 'CGEDJFLK',
  CDEFGIKL: 'CGEDIFLK',
  CDEFGIJL: 'CGEDJFLI',
  CDEFGIJK: 'CGEDJFIK',
  CDEFGHKL: 'CGEDHFLK',
  CDEFGHJL: 'CGJDHFLE',
  CDEFGHJK: 'CGJDHFEK',
  CDEFGHIL: 'CGEDHFLI',
  CDEFGHIK: 'CGEDHFIK',
  CDEFGHIJ: 'CGJDHFEI',
  BFGHIJKL: 'HJBFIGLK',
  BEGHIJKL: 'EJIBHGLK',
  BEFHIJKL: 'EJBFIHLK',
  BEFGIJKL: 'EJBFIGLK',
  BEFGHJKL: 'EJBFHGLK',
  BEFGHIKL: 'EGBFIHLK',
  BEFGHIJL: 'EJBFHGLI',
  BEFGHIJK: 'EJBFHGIK',
  BDGHIJKL: 'HJBDIGLK',
  BDFHIJKL: 'HJBDIFLK',
  BDFGIJKL: 'IGBDJFLK',
  BDFGHJKL: 'HGBDJFLK',
  BDFGHIKL: 'HGBDIFLK',
  BDFGHIJL: 'HGBDJFLI',
  BDFGHIJK: 'HGBDJFIK',
  BDEHIJKL: 'EJBDIHLK',
  BDEGIJKL: 'EJBDIGLK',
  BDEGHJKL: 'EJBDHGLK',
  BDEGHIKL: 'EGBDIHLK',
  BDEGHIJL: 'EJBDHGLI',
  BDEGHIJK: 'EJBDHGIK',
  BDEFIJKL: 'EJBDIFLK',
  BDEFHJKL: 'EJBDHFLK',
  BDEFHIKL: 'EIBDHFLK',
  BDEFHIJL: 'EJBDHFLI',
  BDEFHIJK: 'EJBDHFIK',
  BDEFGJKL: 'EGBDJFLK',
  BDEFGIKL: 'EGBDIFLK',
  BDEFGIJL: 'EGBDJFLI',
  BDEFGIJK: 'EGBDJFIK',
  BDEFGHKL: 'EGBDHFLK',
  BDEFGHJL: 'HGBDJFLE',
  BDEFGHJK: 'HGBDJFEK',
  BDEFGHIL: 'EGBDHFLI',
  BDEFGHIK: 'EGBDHFIK',
  BDEFGHIJ: 'HGBDJFEI',
  BCGHIJKL: 'HJBCIGLK',
  BCFHIJKL: 'HJBCIFLK',
  BCFGIJKL: 'IGBCJFLK',
  BCFGHJKL: 'HGBCJFLK',
  BCFGHIKL: 'HGBCIFLK',
  BCFGHIJL: 'HGBCJFLI',
  BCFGHIJK: 'HGBCJFIK',
  BCEHIJKL: 'EJBCIHLK',
  BCEGIJKL: 'EJBCIGLK',
  BCEGHJKL: 'EJBCHGLK',
  BCEGHIKL: 'EGBCIHLK',
  BCEGHIJL: 'EJBCHGLI',
  BCEGHIJK: 'EJBCHGIK',
  BCEFIJKL: 'EJBCIFLK',
  BCEFHJKL: 'EJBCHFLK',
  BCEFHIKL: 'EIBCHFLK',
  BCEFHIJL: 'EJBCHFLI',
  BCEFHIJK: 'EJBCHFIK',
  BCEFGJKL: 'EGBCJFLK',
  BCEFGIKL: 'EGBCIFLK',
  BCEFGIJL: 'EGBCJFLI',
  BCEFGIJK: 'EGBCJFIK',
  BCEFGHKL: 'EGBCHFLK',
  BCEFGHJL: 'HGBCJFLE',
  BCEFGHJK: 'HGBCJFEK',
  BCEFGHIL: 'EGBCHFLI',
  BCEFGHIK: 'EGBCHFIK',
  BCEFGHIJ: 'HGBCJFEI',
  BCDHIJKL: 'HJBCIDLK',
  BCDGIJKL: 'IGBCJDLK',
  BCDGHJKL: 'HGBCJDLK',
  BCDGHIKL: 'HGBCIDLK',
  BCDGHIJL: 'HGBCJDLI',
  BCDGHIJK: 'HGBCJDIK',
  BCDFIJKL: 'CJBDIFLK',
  BCDFHJKL: 'CJBDHFLK',
  BCDFHIKL: 'CIBDHFLK',
  BCDFHIJL: 'CJBDHFLI',
  BCDFHIJK: 'CJBDHFIK',
  BCDFGJKL: 'CGBDJFLK',
  BCDFGIKL: 'CGBDIFLK',
  BCDFGIJL: 'CGBDJFLI',
  BCDFGIJK: 'CGBDJFIK',
  BCDFGHKL: 'CGBDHFLK',
  BCDFGHJL: 'CGBDHFLJ',
  BCDFGHJK: 'HGBCJFDK',
  BCDFGHIL: 'CGBDHFLI',
  BCDFGHIK: 'CGBDHFIK',
  BCDFGHIJ: 'HGBCJFDI',
  BCDEIJKL: 'EJBCIDLK',
  BCDEHJKL: 'EJBCHDLK',
  BCDEHIKL: 'EIBCHDLK',
  BCDEHIJL: 'EJBCHDLI',
  BCDEHIJK: 'EJBCHDIK',
  BCDEGJKL: 'EGBCJDLK',
  BCDEGIKL: 'EGBCIDLK',
  BCDEGIJL: 'EGBCJDLI',
  BCDEGIJK: 'EGBCJDIK',
  BCDEGHKL: 'EGBCHDLK',
  BCDEGHJL: 'HGBCJDLE',
  BCDEGHJK: 'HGBCJDEK',
  BCDEGHIL: 'EGBCHDLI',
  BCDEGHIK: 'EGBCHDIK',
  BCDEGHIJ: 'HGBCJDEI',
  BCDEFJKL: 'CJBDEFLK',
  BCDEFIKL: 'CEBDIFLK',
  BCDEFIJL: 'CJBDEFLI',
  BCDEFIJK: 'CJBDEFIK',
  BCDEFHKL: 'CEBDHFLK',
  BCDEFHJL: 'CJBDHFLE',
  BCDEFHJK: 'CJBDHFEK',
  BCDEFHIL: 'CEBDHFLI',
  BCDEFHIK: 'CEBDHFIK',
  BCDEFHIJ: 'CJBDHFEI',
  BCDEFGKL: 'CGBDEFLK',
  BCDEFGJL: 'CGBDJFLE',
  BCDEFGJK: 'CGBDJFEK',
  BCDEFGIL: 'CGBDEFLI',
  BCDEFGIK: 'CGBDEFIK',
  BCDEFGIJ: 'CGBDJFEI',
  BCDEFGHL: 'CGBDHFLE',
  BCDEFGHK: 'CGBDHFEK',
  BCDEFGHJ: 'HGBCJFDE',
  BCDEFGHI: 'CGBDHFEI',
  AFGHIJKL: 'HJIFAGLK',
  AEGHIJKL: 'EJIAHGLK',
  AEFHIJKL: 'EJIFAHLK',
  AEFGIJKL: 'EJIFAGLK',
  AEFGHJKL: 'EGJFAHLK',
  AEFGHIKL: 'EGIFAHLK',
  AEFGHIJL: 'EGJFAHLI',
  AEFGHIJK: 'EGJFAHIK',
  ADGHIJKL: 'HJIDAGLK',
  ADFHIJKL: 'HJIDAFLK',
  ADFGIJKL: 'IGJDAFLK',
  ADFGHJKL: 'HGJDAFLK',
  ADFGHIKL: 'HGIDAFLK',
  ADFGHIJL: 'HGJDAFLI',
  ADFGHIJK: 'HGJDAFIK',
  ADEHIJKL: 'EJIDAHLK',
  ADEGIJKL: 'EJIDAGLK',
  ADEGHJKL: 'EGJDAHLK',
  ADEGHIKL: 'EGIDAHLK',
  ADEGHIJL: 'EGJDAHLI',
  ADEGHIJK: 'EGJDAHIK',
  ADEFIJKL: 'EJIDAFLK',
  ADEFHJKL: 'HJEDAFLK',
  ADEFHIKL: 'HEIDAFLK',
  ADEFHIJL: 'HJEDAFLI',
  ADEFHIJK: 'HJEDAFIK',
  ADEFGJKL: 'EGJDAFLK',
  ADEFGIKL: 'EGIDAFLK',
  ADEFGIJL: 'EGJDAFLI',
  ADEFGIJK: 'EGJDAFIK',
  ADEFGHKL: 'HGEDAFLK',
  ADEFGHJL: 'HGJDAFLE',
  ADEFGHJK: 'HGJDAFEK',
  ADEFGHIL: 'HGEDAFLI',
  ADEFGHIK: 'HGEDAFIK',
  ADEFGHIJ: 'HGJDAFEI',
  ACGHIJKL: 'HJICAGLK',
  ACFHIJKL: 'HJICAFLK',
  ACFGIJKL: 'IGJCAFLK',
  ACFGHJKL: 'HGJCAFLK',
  ACFGHIKL: 'HGICAFLK',
  ACFGHIJL: 'HGJCAFLI',
  ACFGHIJK: 'HGJCAFIK',
  ACEHIJKL: 'EJICAHLK',
  ACEGIJKL: 'EJICAGLK',
  ACEGHJKL: 'EGJCAHLK',
  ACEGHIKL: 'EGICAHLK',
  ACEGHIJL: 'EGJCAHLI',
  ACEGHIJK: 'EGJCAHIK',
  ACEFIJKL: 'EJICAFLK',
  ACEFHJKL: 'HJECAFLK',
  ACEFHIKL: 'HEICAFLK',
  ACEFHIJL: 'HJECAFLI',
  ACEFHIJK: 'HJECAFIK',
  ACEFGJKL: 'EGJCAFLK',
  ACEFGIKL: 'EGICAFLK',
  ACEFGIJL: 'EGJCAFLI',
  ACEFGIJK: 'EGJCAFIK',
  ACEFGHKL: 'HGECAFLK',
  ACEFGHJL: 'HGJCAFLE',
  ACEFGHJK: 'HGJCAFEK',
  ACEFGHIL: 'HGECAFLI',
  ACEFGHIK: 'HGECAFIK',
  ACEFGHIJ: 'HGJCAFEI',
  ACDHIJKL: 'HJICADLK',
  ACDGIJKL: 'IGJCADLK',
  ACDGHJKL: 'HGJCADLK',
  ACDGHIKL: 'HGICADLK',
  ACDGHIJL: 'HGJCADLI',
  ACDGHIJK: 'HGJCADIK',
  ACDFIJKL: 'CJIDAFLK',
  ACDFHJKL: 'HJFCADLK',
  ACDFHIKL: 'HFICADLK',
  ACDFHIJL: 'HJFCADLI',
  ACDFHIJK: 'HJFCADIK',
  ACDFGJKL: 'CGJDAFLK',
  ACDFGIKL: 'CGIDAFLK',
  ACDFGIJL: 'CGJDAFLI',
  ACDFGIJK: 'CGJDAFIK',
  ACDFGHKL: 'HGFCADLK',
  ACDFGHJL: 'CGJDAFLH',
  ACDFGHJK: 'HGJCAFDK',
  ACDFGHIL: 'HGFCADLI',
  ACDFGHIK: 'HGFCADIK',
  ACDFGHIJ: 'HGJCAFDI',
  ACDEIJKL: 'EJICADLK',
  ACDEHJKL: 'HJECADLK',
  ACDEHIKL: 'HEICADLK',
  ACDEHIJL: 'HJECADLI',
  ACDEHIJK: 'HJECADIK',
  ACDEGJKL: 'EGJCADLK',
  ACDEGIKL: 'EGICADLK',
  ACDEGIJL: 'EGJCADLI',
  ACDEGIJK: 'EGJCADIK',
  ACDEGHKL: 'HGECADLK',
  ACDEGHJL: 'HGJCADLE',
  ACDEGHJK: 'HGJCADEK',
  ACDEGHIL: 'HGECADLI',
  ACDEGHIK: 'HGECADIK',
  ACDEGHIJ: 'HGJCADEI',
  ACDEFJKL: 'CJEDAFLK',
  ACDEFIKL: 'CEIDAFLK',
  ACDEFIJL: 'CJEDAFLI',
  ACDEFIJK: 'CJEDAFIK',
  ACDEFHKL: 'HEFCADLK',
  ACDEFHJL: 'HJFCADLE',
  ACDEFHJK: 'HJECAFDK',
  ACDEFHIL: 'HEFCADLI',
  ACDEFHIK: 'HEFCADIK',
  ACDEFHIJ: 'HJECAFDI',
  ACDEFGKL: 'CGEDAFLK',
  ACDEFGJL: 'CGJDAFLE',
  ACDEFGJK: 'CGJDAFEK',
  ACDEFGIL: 'CGEDAFLI',
  ACDEFGIK: 'CGEDAFIK',
  ACDEFGIJ: 'CGJDAFEI',
  ACDEFGHL: 'HGFCADLE',
  ACDEFGHK: 'HGECAFDK',
  ACDEFGHJ: 'HGJCAFDE',
  ACDEFGHI: 'HGECAFDI',
  ABGHIJKL: 'HJBAIGLK',
  ABFHIJKL: 'HJBAIFLK',
  ABFGIJKL: 'IJBFAGLK',
  ABFGHJKL: 'HJBFAGLK',
  ABFGHIKL: 'HGBAIFLK',
  ABFGHIJL: 'HJBFAGLI',
  ABFGHIJK: 'HJBFAGIK',
  ABEHIJKL: 'EJBAIHLK',
  ABEGIJKL: 'EJBAIGLK',
  ABEGHJKL: 'EJBAHGLK',
  ABEGHIKL: 'EGBAIHLK',
  ABEGHIJL: 'EJBAHGLI',
  ABEGHIJK: 'EJBAHGIK',
  ABEFIJKL: 'EJBAIFLK',
  ABEFHJKL: 'EJBFAHLK',
  ABEFHIKL: 'EIBFAHLK',
  ABEFHIJL: 'EJBFAHLI',
  ABEFHIJK: 'EJBFAHIK',
  ABEFGJKL: 'EJBFAGLK',
  ABEFGIKL: 'EGBAIFLK',
  ABEFGIJL: 'EJBFAGLI',
  ABEFGIJK: 'EJBFAGIK',
  ABEFGHKL: 'EGBFAHLK',
  ABEFGHJL: 'HJBFAGLE',
  ABEFGHJK: 'HJBFAGEK',
  ABEFGHIL: 'EGBFAHLI',
  ABEFGHIK: 'EGBFAHIK',
  ABEFGHIJ: 'HJBFAGEI',
  ABDHIJKL: 'IJBDAHLK',
  ABDGIJKL: 'IJBDAGLK',
  ABDGHJKL: 'HJBDAGLK',
  ABDGHIKL: 'IGBDAHLK',
  ABDGHIJL: 'HJBDAGLI',
  ABDGHIJK: 'HJBDAGIK',
  ABDFIJKL: 'IJBDAFLK',
  ABDFHJKL: 'HJBDAFLK',
  ABDFHIKL: 'HIBDAFLK',
  ABDFHIJL: 'HJBDAFLI',
  ABDFHIJK: 'HJBDAFIK',
  ABDFGJKL: 'FJBDAGLK',
  ABDFGIKL: 'IGBDAFLK',
  ABDFGIJL: 'FJBDAGLI',
  ABDFGIJK: 'FJBDAGIK',
  ABDFGHKL: 'HGBDAFLK',
  ABDFGHJL: 'HGBDAFLJ',
  ABDFGHJK: 'HGBDAFJK',
  ABDFGHIL: 'HGBDAFLI',
  ABDFGHIK: 'HGBDAFIK',
  ABDFGHIJ: 'HGBDAFIJ',
  ABDEIJKL: 'EJBAIDLK',
  ABDEHJKL: 'EJBDAHLK',
  ABDEHIKL: 'EIBDAHLK',
  ABDEHIJL: 'EJBDAHLI',
  ABDEHIJK: 'EJBDAHIK',
  ABDEGJKL: 'EJBDAGLK',
  ABDEGIKL: 'EGBAIDLK',
  ABDEGIJL: 'EJBDAGLI',
  ABDEGIJK: 'EJBDAGIK',
  ABDEGHKL: 'EGBDAHLK',
  ABDEGHJL: 'HJBDAGLE',
  ABDEGHJK: 'HJBDAGEK',
  ABDEGHIL: 'EGBDAHLI',
  ABDEGHIK: 'EGBDAHIK',
  ABDEGHIJ: 'HJBDAGEI',
  ABDEFJKL: 'EJBDAFLK',
  ABDEFIKL: 'EIBDAFLK',
  ABDEFIJL: 'EJBDAFLI',
  ABDEFIJK: 'EJBDAFIK',
  ABDEFHKL: 'HEBDAFLK',
  ABDEFHJL: 'HJBDAFLE',
  ABDEFHJK: 'HJBDAFEK',
  ABDEFHIL: 'HEBDAFLI',
  ABDEFHIK: 'HEBDAFIK',
  ABDEFHIJ: 'HJBDAFEI',
  ABDEFGKL: 'EGBDAFLK',
  ABDEFGJL: 'EGBDAFLJ',
  ABDEFGJK: 'EGBDAFJK',
  ABDEFGIL: 'EGBDAFLI',
  ABDEFGIK: 'EGBDAFIK',
  ABDEFGIJ: 'EGBDAFIJ',
  ABDEFGHL: 'HGBDAFLE',
  ABDEFGHK: 'HGBDAFEK',
  ABDEFGHJ: 'HGBDAFEJ',
  ABDEFGHI: 'HGBDAFEI',
  ABCHIJKL: 'IJBCAHLK',
  ABCGIJKL: 'IJBCAGLK',
  ABCGHJKL: 'HJBCAGLK',
  ABCGHIKL: 'IGBCAHLK',
  ABCGHIJL: 'HJBCAGLI',
  ABCGHIJK: 'HJBCAGIK',
  ABCFIJKL: 'IJBCAFLK',
  ABCFHJKL: 'HJBCAFLK',
  ABCFHIKL: 'HIBCAFLK',
  ABCFHIJL: 'HJBCAFLI',
  ABCFHIJK: 'HJBCAFIK',
  ABCFGJKL: 'CJBFAGLK',
  ABCFGIKL: 'IGBCAFLK',
  ABCFGIJL: 'CJBFAGLI',
  ABCFGIJK: 'CJBFAGIK',
  ABCFGHKL: 'HGBCAFLK',
  ABCFGHJL: 'HGBCAFLJ',
  ABCFGHJK: 'HGBCAFJK',
  ABCFGHIL: 'HGBCAFLI',
  ABCFGHIK: 'HGBCAFIK',
  ABCFGHIJ: 'HGBCAFIJ',
  ABCEIJKL: 'EJBAICLK',
  ABCEHJKL: 'EJBCAHLK',
  ABCEHIKL: 'EIBCAHLK',
  ABCEHIJL: 'EJBCAHLI',
  ABCEHIJK: 'EJBCAHIK',
  ABCEGJKL: 'EJBCAGLK',
  ABCEGIKL: 'EGBAICLK',
  ABCEGIJL: 'EJBCAGLI',
  ABCEGIJK: 'EJBCAGIK',
  ABCEGHKL: 'EGBCAHLK',
  ABCEGHJL: 'HJBCAGLE',
  ABCEGHJK: 'HJBCAGEK',
  ABCEGHIL: 'EGBCAHLI',
  ABCEGHIK: 'EGBCAHIK',
  ABCEGHIJ: 'HJBCAGEI',
  ABCEFJKL: 'EJBCAFLK',
  ABCEFIKL: 'EIBCAFLK',
  ABCEFIJL: 'EJBCAFLI',
  ABCEFIJK: 'EJBCAFIK',
  ABCEFHKL: 'HEBCAFLK',
  ABCEFHJL: 'HJBCAFLE',
  ABCEFHJK: 'HJBCAFEK',
  ABCEFHIL: 'HEBCAFLI',
  ABCEFHIK: 'HEBCAFIK',
  ABCEFHIJ: 'HJBCAFEI',
  ABCEFGKL: 'EGBCAFLK',
  ABCEFGJL: 'EGBCAFLJ',
  ABCEFGJK: 'EGBCAFJK',
  ABCEFGIL: 'EGBCAFLI',
  ABCEFGIK: 'EGBCAFIK',
  ABCEFGIJ: 'EGBCAFIJ',
  ABCEFGHL: 'HGBCAFLE',
  ABCEFGHK: 'HGBCAFEK',
  ABCEFGHJ: 'HGBCAFEJ',
  ABCEFGHI: 'HGBCAFEI',
  ABCDIJKL: 'IJBCADLK',
  ABCDHJKL: 'HJBCADLK',
  ABCDHIKL: 'HIBCADLK',
  ABCDHIJL: 'HJBCADLI',
  ABCDHIJK: 'HJBCADIK',
  ABCDGJKL: 'CJBDAGLK',
  ABCDGIKL: 'IGBCADLK',
  ABCDGIJL: 'CJBDAGLI',
  ABCDGIJK: 'CJBDAGIK',
  ABCDGHKL: 'HGBCADLK',
  ABCDGHJL: 'HGBCADLJ',
  ABCDGHJK: 'HGBCADJK',
  ABCDGHIL: 'HGBCADLI',
  ABCDGHIK: 'HGBCADIK',
  ABCDGHIJ: 'HGBCADIJ',
  ABCDFJKL: 'CJBDAFLK',
  ABCDFIKL: 'CIBDAFLK',
  ABCDFIJL: 'CJBDAFLI',
  ABCDFIJK: 'CJBDAFIK',
  ABCDFHKL: 'HFBCADLK',
  ABCDFHJL: 'CJBDAFLH',
  ABCDFHJK: 'HJBCAFDK',
  ABCDFHIL: 'HFBCADLI',
  ABCDFHIK: 'HFBCADIK',
  ABCDFHIJ: 'HJBCAFDI',
  ABCDFGKL: 'CGBDAFLK',
  ABCDFGJL: 'CGBDAFLJ',
  ABCDFGJK: 'CGBDAFJK',
  ABCDFGIL: 'CGBDAFLI',
  ABCDFGIK: 'CGBDAFIK',
  ABCDFGIJ: 'CGBDAFIJ',
  ABCDFGHL: 'CGBDAFLH',
  ABCDFGHK: 'HGBCAFDK',
  ABCDFGHJ: 'HGBCAFDJ',
  ABCDFGHI: 'HGBCAFDI',
  ABCDEJKL: 'EJBCADLK',
  ABCDEIKL: 'EIBCADLK',
  ABCDEIJL: 'EJBCADLI',
  ABCDEIJK: 'EJBCADIK',
  ABCDEHKL: 'HEBCADLK',
  ABCDEHJL: 'HJBCADLE',
  ABCDEHJK: 'HJBCADEK',
  ABCDEHIL: 'HEBCADLI',
  ABCDEHIK: 'HEBCADIK',
  ABCDEHIJ: 'HJBCADEI',
  ABCDEGKL: 'EGBCADLK',
  ABCDEGJL: 'EGBCADLJ',
  ABCDEGJK: 'EGBCADJK',
  ABCDEGIL: 'EGBCADLI',
  ABCDEGIK: 'EGBCADIK',
  ABCDEGIJ: 'EGBCADIJ',
  ABCDEGHL: 'HGBCADLE',
  ABCDEGHK: 'HGBCADEK',
  ABCDEGHJ: 'HGBCADEJ',
  ABCDEGHI: 'HGBCADEI',
  ABCDEFKL: 'CEBDAFLK',
  ABCDEFJL: 'CJBDAFLE',
  ABCDEFJK: 'CJBDAFEK',
  ABCDEFIL: 'CEBDAFLI',
  ABCDEFIK: 'CEBDAFIK',
  ABCDEFIJ: 'CJBDAFEI',
  ABCDEFHL: 'HFBCADLE',
  ABCDEFHK: 'HEBCAFDK',
  ABCDEFHJ: 'HJBCAFDE',
  ABCDEFHI: 'HEBCAFDI',
  ABCDEFGL: 'CGBDAFLE',
  ABCDEFGK: 'CGBDAFEK',
  ABCDEFGJ: 'CGBDAFEJ',
  ABCDEFGI: 'CGBDAFEI',
  ABCDEFGH: 'HGBCAFDE',
};
